<app-modal-header title="Mileage Log"></app-modal-header>
<ion-content class="time-modal-content">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-item lines="full" class="time-item">
          <ion-label position="fixed">Date:</ion-label>
          <ion-text>{{ date.format('MMM D, YYYY') }}</ion-text>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-item lines="full" class="time-item">
          <ion-label position="fixed">Total Mileage:</ion-label>
          <ion-text>{{ totalMileage | number }} miles</ion-text>
        </ion-item>
      </ion-col>
    </ion-row>
    <div class="logs">
      <app-mileage-log-card 
        *ngFor="let card of cards" 
        [cardData]="card" 
        [projects]="projects"
        [canEdit]="canEdit"
      ></app-mileage-log-card>
    </div>
  </ion-grid>
  <ion-fab *ngIf="canEdit" vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button class="fab-button" (click)="onAdd()">
      <ion-icon name="add-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
